const LicenseBadgeStyle = {
  base: 'inline-block rounded py-0.5 px-2.5 text-[13px] font-medium whitespace-nowrap text-white',
  starter: 'bg-emerald-600',
  adviser: 'bg-indigo-600',
  elite: 'bg-[#1e3a5f]',
  'elite (legacy)': 'bg-[#1e3a5f]',
  'essential (legacy)': 'bg-blue-600',
  empty: 'text-gray-400',
};

export default LicenseBadgeStyle;
